import { waLink, photoSrc } from "../lib/constants";

const IMG = {
  hero: "https://images.pexels.com/photos/6471913/pexels-photo-6471913.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  about: "https://images.unsplash.com/photo-1698479603408-1a66a6d9e80f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxIVkFDJTIwdGVjaG5pY2lhbnxlbnwwfHx8fDE3OTEyMDUzNjB8MA&ixlib=rb-4.1.0&q=85",
};

export const Landing = ({ settings, onLoginClick }) => {
  const s = settings || {};
  const wa = waLink(s.whatsapp, `Halo ${s.company_name || ""}, saya ingin menanyakan layanan maintenance.`);
  const heroImg = s.hero_image_url || IMG.hero;
  const aboutImg = s.about_image_url || IMG.about;

  const Logo = () =>
    s.logo_url ? (
      <img src={photoSrc(s.logo_url)} alt={s.company_name} className="h-10 w-auto object-contain" />
    ) : (
      <div className="w-10 h-10 rounded-lg bg-[#0F172A] text-teal-400 flex items-center justify-center ring-1 ring-slate-200">
        <i className="ph-bold ph-wrench text-xl" />
      </div>
    );

  const trust = [
    { icon: "ph-seal-check", text: "Standar Mutu ISO 9001" },
    { icon: "ph-shield-check", text: "Pengerjaan Bergaransi" },
    { icon: "ph-lightning", text: "Respons Cepat 24/7" },
  ];

  return (
    <div className="bg-[#F8FAFC] text-[#0F172A] min-h-screen antialiased">
      {/* Nav */}
      <header className="sticky top-0 inset-x-0 z-50 bg-white/90 backdrop-blur-md border-b border-slate-200 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-[72px] flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Logo />
            <div className="leading-tight">
              <p className="font-display text-[15px] sm:text-base text-[#0F172A]">{s.company_name}</p>
              <p className="text-[10px] font-semibold tracking-wider uppercase text-teal-700 hidden sm:block">Facility Maintenance Services</p>
            </div>
          </div>
          <nav className="hidden md:flex items-center gap-8 text-sm font-semibold text-slate-600">
            <a href="#layanan" className="hover:text-teal-700 transition-colors">Layanan</a>
            <a href="#tentang" className="hover:text-teal-700 transition-colors">Tentang</a>
            <a href="#kontak" className="hover:text-teal-700 transition-colors">Kontak</a>
          </nav>
          <div className="flex items-center gap-2.5">
            <button onClick={onLoginClick} className="inline-flex items-center gap-1.5 border border-slate-300 text-[#0F172A] hover:bg-slate-50 px-4 py-2 rounded-lg text-xs font-bold transition-colors" data-testid="landing-login-btn">
              <i className="ph-bold ph-lock-key" /> Portal Pelanggan
            </button>
            <a href={wa} target="_blank" rel="noreferrer" className="hidden sm:inline-flex items-center gap-1.5 bg-[#EA580C] hover:bg-[#c2410c] text-white px-4 py-2 rounded-lg text-xs font-bold transition-colors shadow-sm">
              <i className="ph-bold ph-phone-call" /> Konsultasi
            </a>
          </div>
        </div>
      </header>

      {/* Hero — asymmetric 60/40 */}
      <section className="relative overflow-hidden border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-20 grid lg:grid-cols-12 gap-10 lg:gap-12 items-center">
          <div className="lg:col-span-7">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-teal-50 border border-teal-200 text-teal-800 text-xs font-bold tracking-wide">
              <span className="w-1.5 h-1.5 rounded-full bg-teal-500" /> {s.tagline}
            </span>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#0F172A] leading-[1.05] mt-5 tracking-tight">
              {s.hero_title}
            </h1>
            <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed max-w-xl">{s.hero_subtitle}</p>
            <div className="mt-8 flex flex-wrap gap-3">
              <a href={wa} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 bg-[#EA580C] hover:bg-[#c2410c] text-white px-6 py-3.5 rounded-lg text-sm font-bold shadow-lg shadow-orange-600/20 transition-all hover:-translate-y-0.5" data-testid="hero-wa-btn">
                <i className="ph-bold ph-whatsapp-logo text-lg" /> Konsultasi Maintenance
              </a>
              <button onClick={onLoginClick} className="inline-flex items-center gap-2 bg-white border border-slate-300 text-[#0F172A] hover:bg-slate-50 px-6 py-3.5 rounded-lg text-sm font-bold transition-colors">
                <i className="ph-bold ph-chart-line-up" /> Lihat Status Gedung
              </button>
            </div>
            <div className="mt-9 flex flex-wrap gap-x-7 gap-y-3 pt-7 border-t border-slate-200">
              {trust.map((t, i) => (
                <div key={i} className="flex items-center gap-2 text-sm font-semibold text-slate-700">
                  <i className={`ph-bold ${t.icon} text-teal-600 text-lg`} /> {t.text}
                </div>
              ))}
            </div>
          </div>
          <div className="lg:col-span-5">
            <div className="relative">
              <div className="rounded-2xl overflow-hidden ring-1 ring-slate-200 shadow-2xl shadow-slate-900/10">
                <img src={heroImg} alt="Teknisi maintenance" className="w-full h-[320px] lg:h-[420px] object-cover" />
              </div>
              <div className="absolute -bottom-5 -left-3 sm:left-6 bg-white rounded-xl border border-slate-200 shadow-xl px-4 py-3 flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-emerald-50 text-emerald-600 flex items-center justify-center"><i className="ph-bold ph-check-circle text-xl" /></div>
                <div className="leading-tight">
                  <p className="font-display text-[#0F172A] text-sm">Terjadwal & Terdokumentasi</p>
                  <p className="text-[11px] text-slate-500 font-medium">Laporan per gedung & triwulan</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats band */}
      <section className="bg-[#0F172A] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 grid grid-cols-2 lg:grid-cols-4 gap-6">
          {[
            { k: "150+", v: "Unit AC Ditangani" },
            { k: "12", v: "Gedung Dikelola" },
            { k: "24/7", v: "Dukungan Teknis" },
            { k: "100%", v: "Laporan Transparan" },
          ].map((m, i) => (
            <div key={i} className="border-l-2 border-teal-500 pl-4">
              <p className="font-display text-3xl sm:text-4xl text-white">{m.k}</p>
              <p className="text-xs font-semibold tracking-wide uppercase text-slate-400 mt-1">{m.v}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Services */}
      <section id="layanan" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="max-w-2xl mb-12">
          <span className="text-xs font-extrabold tracking-[0.2em] text-teal-700">LAYANAN KAMI</span>
          <h2 className="font-display text-3xl sm:text-4xl text-[#0F172A] mt-3 leading-tight tracking-tight">Solusi maintenance menyeluruh untuk gedung Anda</h2>
          <div className="mt-4 h-1 w-14 bg-[#EA580C] rounded-full" />
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {(s.services || []).map((srv, i) => (
            <div key={i} className="group bg-white border border-slate-200 rounded-xl p-6 hover:border-teal-400 hover:shadow-lg hover:shadow-slate-900/5 transition-all" data-testid={`service-card-${i}`}>
              <div className="w-12 h-12 rounded-lg bg-teal-50 text-teal-700 flex items-center justify-center ring-1 ring-teal-100 group-hover:bg-[#0F172A] group-hover:text-teal-400 transition-colors">
                <i className={`ph-bold ${srv.icon || "ph-wrench"} text-2xl`} />
              </div>
              <h3 className="mt-5 font-display text-lg text-[#0F172A]">{srv.title}</h3>
              <p className="text-sm text-slate-600 mt-2 leading-relaxed">{srv.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* About */}
      <section id="tentang" className="bg-white border-y border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 grid lg:grid-cols-2 gap-14 items-center">
          <div className="relative order-2 lg:order-1">
            <div className="rounded-2xl overflow-hidden ring-1 ring-slate-200 shadow-xl">
              <img src={aboutImg} alt="Tentang kami" className="w-full object-cover aspect-[4/3]" />
            </div>
            <div className="absolute -top-4 -right-4 bg-[#EA580C] text-white rounded-xl px-4 py-3 shadow-lg hidden sm:block">
              <p className="font-display text-2xl leading-none">10+</p>
              <p className="text-[10px] font-bold uppercase tracking-wide mt-1">Tahun Pengalaman</p>
            </div>
          </div>
          <div className="order-1 lg:order-2">
            <span className="text-xs font-extrabold tracking-[0.2em] text-teal-700">TENTANG KAMI</span>
            <h2 className="font-display text-3xl sm:text-4xl text-[#0F172A] mt-3 leading-tight tracking-tight">{s.about_title}</h2>
            <p className="mt-6 text-slate-600 leading-relaxed whitespace-pre-line">{s.about_text}</p>
            {s.features?.length > 0 && (
              <div className="mt-7 grid sm:grid-cols-2 gap-3">
                {s.features.map((f, i) => (
                  <div key={i} className="flex gap-3 items-start">
                    <i className="ph-bold ph-check-circle text-teal-600 text-lg shrink-0 mt-0.5" />
                    <div>
                      <p className="font-bold text-[#0F172A] text-sm">{f.title}</p>
                      <p className="text-xs text-slate-500 leading-relaxed">{f.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            )}
            <a href={wa} target="_blank" rel="noreferrer" className="mt-8 inline-flex items-center gap-2 text-teal-700 font-bold hover:text-teal-900">
              <i className="ph-bold ph-whatsapp-logo text-lg" /> Konsultasi Gratis <i className="ph-bold ph-arrow-right" />
            </a>
          </div>
        </div>
      </section>

      {/* Contact */}
      <section id="kontak" className="bg-white border-t border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 grid lg:grid-cols-2 gap-12 items-start">
          <div>
            <span className="text-xs font-extrabold tracking-[0.2em] text-teal-700">KONTAK</span>
            <h2 className="font-display text-3xl sm:text-4xl text-[#0F172A] mt-3 leading-tight tracking-tight">Hubungi tim kami</h2>
            <div className="mt-8 space-y-4">
              {[
                { icon: "ph-map-pin", label: "Alamat", value: s.address },
                s.whatsapp && { icon: "ph-whatsapp-logo", label: "WhatsApp", value: s.whatsapp, link: wa },
                s.email && { icon: "ph-envelope-simple", label: "Email", value: s.email },
                s.hours && { icon: "ph-clock", label: "Jam Operasional", value: s.hours },
              ].filter(Boolean).map((c, i) => (
                <div key={i} className="flex gap-4 items-start">
                  <div className="w-11 h-11 rounded-lg bg-teal-50 ring-1 ring-teal-100 text-teal-700 flex items-center justify-center shrink-0">
                    <i className={`ph-bold ${c.icon} text-lg`} />
                  </div>
                  <div>
                    <p className="font-bold text-[#0F172A] text-sm">{c.label}</p>
                    {c.link ? <a href={c.link} target="_blank" rel="noreferrer" className="text-sm text-teal-700 hover:underline">{c.value}</a>
                      : <p className="text-sm text-slate-600">{c.value}</p>}
                  </div>
                </div>
              ))}
            </div>
          </div>
          {(s.map_coords || s.address) && (
            <div className="space-y-3">
              <div className="rounded-2xl overflow-hidden ring-1 ring-slate-200 shadow-lg h-80 lg:h-[26rem]">
                <iframe title="Lokasi" className="w-full h-full" style={{ border: 0 }} loading="lazy"
                  src={`https://www.google.com/maps?q=${encodeURIComponent(s.map_coords || s.address)}&z=16&output=embed`} />
              </div>
              <a href={s.maps_url || `https://www.google.com/maps?q=${encodeURIComponent(s.map_coords || s.address)}`} target="_blank" rel="noreferrer"
                className="inline-flex items-center gap-2 text-sm font-bold text-teal-700 hover:text-teal-900" data-testid="open-in-maps">
                <i className="ph-bold ph-navigation-arrow" /> Buka di Google Maps <i className="ph-bold ph-arrow-up-right" />
              </a>
            </div>
          )}
        </div>
      </section>

      <footer className="bg-[#0F172A] text-slate-300">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            {s.logo_url ? <img src={photoSrc(s.logo_url)} alt="" className="h-8 w-auto object-contain" /> : <i className="ph-bold ph-wrench text-teal-400 text-xl" />}
            <span className="font-display text-white text-sm">{s.company_name}</span>
          </div>
          <p className="text-xs text-slate-500">© {new Date().getFullYear()} {s.company_name}. Semua hak dilindungi.</p>
          <button onClick={onLoginClick} className="text-xs font-bold text-teal-400 hover:text-teal-300">Login Admin / Pelanggan</button>
        </div>
      </footer>
    </div>
  );
};
